import React from 'react'
import { Button, Table, Container, Row, Col, Label } from 'reactstrap'
import {
    queryQuote,
    updateQuote,
} from '../model/request/quotes'
import { formatAsDollarValue, moneyText, dateOffsetText } from '../model/Formatting'
import { getCustomerCompanyInfo } from '../model/request/customer_info'
import { getCompanyBankNickNames } from '../model/request/bank'
import { JustDate } from '../model/JustDate'
import { Account } from '../model/Account'
import SimpleDropdown from '../view/DropDownView'
import NumberTextField from '../view/NumberTextField'
import dateFormat from 'dateformat'

class CustomerPaymentsViewController extends React.Component {

    constructor(props) {
        super(props)
        const account = Account.fromCookieAndLocalStorage()
        this.state = {
            'jobs': [],
            'nicknames': [],
            'company_info': null,
            'account': account,
        }
    }

    componentDidMount() {
        this.props.turnOnLoader(3)

        queryQuote({
            'is_shipped': true,
            ...(this.props.query ? this.props.query : {})
        }).then(
            (quotes) => {
                this.setState({
                    'jobs': quotes.map((quote) => {
                        quote.current_payment = quote.left_to_pay
                        return quote
                    }),
                }, () => this.updateAllJobsPaymentValue())
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        getCustomerCompanyInfo().then(
            (company_info) => {
                this.setState({
                    'company_info': company_info,
                }, () => this.updateAllJobsPaymentValue())
                this.props.turnOffLoader()
            },
        )

        getCompanyBankNickNames().then(
            (nicknames) => {
                this.setState({
                    'nicknames': nicknames,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    updateAllJobsPaymentValue() {
        if (this.state.company_info === null) { return }
        if (this.state.jobs.length === 0) { return }
        this.setState({
            'jobs': this.state.jobs.map((quote) => {
                const dueDate = quote.shipped_date.advanceDate(
                    this.state.company_info.payment_days,
                )
                const lastDatePaid = quote.last_date_paid
                const fromDateForInterest = lastDatePaid && (dueDate.toDate() < lastDatePaid.toDate())
                    ? lastDatePaid
                    : dueDate
                quote.current_payment = quote.amountLeftPlusInterest(fromDateForInterest)
                return quote
            }),
        })
    }

    makePayment(index) {
        this.props.turnOnLoader()

        const dueDate = this.state.jobs[index].shipped_date.advanceDate(
            this.state.company_info.payment_days,
        )
        const lastDatePaid = this.state.jobs[index].last_date_paid
        const fromDateForInterest = lastDatePaid && (dueDate.toDate() < lastDatePaid.toDate())
            ? lastDatePaid
            : dueDate
        const amountLeft = this.state.jobs[index].amountLeftPlusInterest(fromDateForInterest)

        this.state.jobs[index].addPayment(
            Number.parseFloat(this.state.jobs[index].current_payment),
            this.state.jobs[index].payment_nick_name,
            new JustDate(),
        )

        updateQuote({
            'id': this.state.jobs[index].id,
            'last_date_paid': new JustDate(),
            'left_to_pay': amountLeft -
                Number.parseFloat(this.state.jobs[index].current_payment),
            'payment_history': this.state.jobs[index].payment_history,
        }).then(
            (success) => {
                this.setState((state) => {
                    state.jobs[index].last_date_paid = new JustDate()
                    state.jobs[index].left_to_pay =
                        amountLeft -
                            Number.parseFloat(this.state.jobs[index].current_payment)
                    return {
                        'jobs': state.jobs,
                    }
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.state.jobs[index].payment_history.pop()
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    renderRows() {
        if (this.state.company_info === null) {
            return <></>
        }
        return this.state.jobs.map((job, job_index) => {
            const dueDate = job.shipped_date.advanceDate(
                this.state.company_info.payment_days,
            )
            const lastDatePaid = job.last_date_paid
            const fromDateForInterest = lastDatePaid && (dueDate.toDate() < lastDatePaid.toDate())
                ? lastDatePaid
                : dueDate
            return <tr key={"row"+job_index}>
                <td>{job.quote_sequence}</td>
                <td><a href={'/quote/' + job.id} text={job.job_name}>{job.job_name}</a></td>
                <td>
                    <a
                        href={'/api/pdf/invoice/' + job.id + '/' + job.job_name + '-invoice.pdf'}
                        target="_blank"
                        text={moneyText(job.total_price)}
                    >{formatAsDollarValue(job.total_price)}</a></td>
                <td>{(() => {
                    const value = job.totalPayments() + job.amountLeftPlusInterest(fromDateForInterest) -
                        job.total_price
                    return <span text={moneyText(value)}>{formatAsDollarValue(value, true)}</span>
                })()}</td>
                <td>{(() => {
                    const value = job.totalPayments() + job.amountLeftPlusInterest(fromDateForInterest)
                    return <span text={moneyText(value)}>{formatAsDollarValue(value, true)}</span>
                })()}</td>
                <td><span text={moneyText(job.amountLeftPlusInterest(fromDateForInterest))}>{formatAsDollarValue(job.amountLeftPlusInterest(fromDateForInterest))}</span></td>
                <td><span text={dateOffsetText(job.shipped_date)}>{dateFormat(job.shipped_date.toDateTime(), 'mmmm d, yyyy')}</span></td>
                <td>{(() => {
                    const date = job.shipped_date.advanceDate(this.state.company_info.payment_days)
                    return <span text={dateOffsetText(date)}>{dateFormat(date.toDateTime(), 'mmmm d, yyyy')}</span>
                })()}</td>
                {this.props.canMakePayment
                ? <td>
                    <NumberTextField
                        showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                        style={{
                            'textAlign': 'right',
                        }}
                        value={job.current_payment}
                        onChange={(e) => {
                            job.current_payment = e.target.value
                            this.setState({})
                        }}/>
                </td>
                :<></>}
                <td>
                {job.left_to_pay <= 0.0
                    ? <Label>Paid Off</Label>
                    : <SimpleDropdown
                        index={this.state.nicknames.map((x) => x.nick_name).indexOf(job.payment_nick_name)}
                        values={this.state.nicknames.map((x) => x.nick_name)}
                        onChange={(index) => {
                            this.setState((state) => {
                                state.jobs[job_index].payment_nick_name = this.state.nicknames[index].nick_name
                                return {
                                    'jobs': state.jobs,
                                }
                            })
                        }} />
                }</td>
                <td>
                {job.left_to_pay <= 0.0
                    ?  <Label><span text={dateOffsetText(job.last_date_paid)}>{dateFormat(job.last_date_paid.toDateTime(), 'mmmm d, yyyy')}</span></Label>
                    : <Button
                        onClick={() => {
                            this.makePayment(job_index)
                        }}
                    >Make Payment</Button>
                }</td>
            </tr>
        })
    }

    render() {
        return <Container>
            <Row><Col><Container style={{'overflowX': 'auto'}}><Table>
                <thead>
                    <tr>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Invoice Number</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Job Name</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Invoice Amount</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Interest Calculated</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Total Amount Due</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Amount Left</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Ship Date</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Due Date</th>
                        {this.props.canMakePayment
                            ? <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Payment</th>
                            : <></>
                        }
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Payment Method</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Make Payment</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderRows()}
                </tbody>
            </Table></Container></Col></Row>
        </Container>
    }
}

export default CustomerPaymentsViewController;
